export default "__VITE_ASSET__9IyY_GsY__"